var _a;
export var TestTag;
(function (TestTag) {
    // Branding & Logo
    TestTag["ApplicationLogo"] = "IMG_APP_LOGO";
    // Page Headers
    TestTag["PrimaryPageHeader"] = "HDR_PRIMARY_TITLE";
    TestTag["HomePageHeaderContainer"] = "HDR_HOMEPAGE";
    TestTag["SecondaryHeadingContainer"] = "CNT_SECONDARY_HEADING";
    // Login / Auth (Okta-managed)
    TestTag["EmailLabel"] = "LBL_EMAIL";
    TestTag["EmailTextbox"] = "TXT_EMAIL";
    TestTag["RememberMeCheckbox"] = "CHK_REMEMBER_ME";
    TestTag["RememberMeLabel"] = "LBL_REMEMBER_ME";
    TestTag["UnlockAccountLink"] = "LNK_UNLOCK_ACCOUNT";
    // Primary Action Buttons
    TestTag["PrimaryActionButtonNext"] = "BTN_NEXT";
    TestTag["PrimaryActionButtonSubmit"] = "BTN_SUBMIT";
    TestTag["BtnBack"] = "BTN_BACK";
    TestTag["BtnCreateReport"] = "BTN_CREATE_REPORT";
    TestTag["BtnSaveChanges"] = "BTN_SAVE_CHANGES";
    TestTag["BtnRevertChanges"] = "BTN_REVERT_CHANGES";
    TestTag["BtnEditMode"] = "BTN_EDIT_MODE";
    TestTag["BtnExitEditMode"] = "BTN_EXIT_EDIT_MODE";
    TestTag["BtnSaveSettings"] = "BTN_SAVE_SETTINGS";
    TestTag["BtnResetFilters"] = "BTN_RESET_FILTERS";
    TestTag["BtnInfoIcon"] = "BTN_INFO";
    TestTag["BtnDownloadCsv"] = "BTN_DOWNLOAD_CSV";
    TestTag["BtnNineBoxTableView"] = "BTN_TABLE_VIEW";
    TestTag["BtnNineBoxGridView"] = "BTN_GRID_VIEW";
    TestTag["BtnSwitchToHeidrick"] = "BTN_SWITCH_TO_HEIDRICK_VIEW";
    TestTag["BtnSwitchToConfidential"] = "BTN_SWITCH_TO_CONFIDENTIAL_VIEW";
    // Links / Navigation
    TestTag["HelpLink"] = "LNK_HELP";
    TestTag["BreadcrumbItem"] = "LNK_BREADCRUMB_ITEM";
    TestTag["BackToButton"] = "BTN_BACK_TO";
    TestTag["BackToLink"] = "LNK_BACK_TO";
    // Header Menu
    TestTag["HeaderContainer"] = "CNT_HEADER";
    TestTag["HeaderAppBar"] = "BAR_HEADER";
    TestTag["HeaderMenuMyProfile"] = "MNU_MY_PROFILE";
    TestTag["HeaderBtnAccountMenu"] = "BTN_ACCOUNT_MENU";
    TestTag["HeaderMenuLogout"] = "MNU_LOGOUT";
    TestTag["HeaderMenuSettings"] = "MNU_SETTINGS";
    // Pages
    TestTag["DashboardPage"] = "PG_DASHBOARD";
    TestTag["CohortInsightsPage"] = "PG_COHORT_INSIGHTS";
    TestTag["FilteredOverviewPage"] = "PG_FILTERED_OVERVIEW";
    TestTag["HeatmappedPage"] = "PG_HEATMAPPED";
    // Dashboard Containers
    TestTag["DashboardOuterContainer"] = "CNT_DASHBOARD_OUTER";
    TestTag["DashboardInnerContainer"] = "CNT_DASHBOARD_INNER";
    // Panels / Containers
    TestTag["DiversitySettingsPanel"] = "PNL_DIVERSITY_SETTINGS";
    TestTag["FiltersPanel"] = "PNL_FILTERS";
    TestTag["NineBoxFilterPanel"] = "PNL_NINE_BOX_FILTER";
    TestTag["SummaryPanel"] = "PNL_SUMMARY";
    TestTag["DialogContainer"] = "CNT_DIALOG";
    TestTag["TableContainer"] = "TBL_CONTAINER";
    // Bars
    TestTag["FiltersBar"] = "BAR_FILTERS";
    TestTag["OverviewTabsBar"] = "BAR_OVERVIEW_TABS";
    // Dropdown / Options
    TestTag["DropdownContainer"] = "DRP_ACTION_MENU";
    TestTag["DropdownOptionEdit"] = "OPT_EDIT";
    TestTag["DropdownOptionArchive"] = "OPT_ARCHIVE";
    TestTag["OverflowMenuTrigger"] = "BTN_OVERFLOW_MENU";
    TestTag["MenuOptionDownloadReports"] = "OPT_DOWNLOAD_REPORTS";
    TestTag["MenuOptionRegenerate"] = "OPT_REGENERATE";
    TestTag["DropdownSelector"] = "DRP_ACTION_SELECTOR";
    TestTag["OptionsListContainer"] = "LST_ACTION_OPTIONS";
    // Text / Labels
    TestTag["FooterCopyright"] = "TXT_FOOTER_COPYRIGHT";
    TestTag["LeaderCount"] = "TXT_LEADER_COUNT";
    // Form Controls
    TestTag["CheckboxOption"] = "CHK_OPTION";
    // Dynamic / indexed components
    TestTag["AutocompleteField"] = "SEL_AUTOCOMPLETE";
    TestTag["MultiSelectFilter"] = "SEL_MULTISELECT_FILTER";
    TestTag["FilterSection"] = "SEC_FILTER";
    TestTag["FilterDropdownHeader"] = "HDR_FILTER_DROPDOWN";
    TestTag["ToggleButton"] = "BTN_TOGGLE";
    TestTag["InfoBar"] = "BAR_INFO";
    TestTag["OverviewTabPanel"] = "PNL_TAB_PANEL";
    TestTag["OverviewTab"] = "TAB_ITEM";
    TestTag["NavItem"] = "NAV_ITEM";
    TestTag["PaneSelectorItem"] = "ITM_PANE_SELECTOR";
    TestTag["PaneSelectorNestedItem"] = "ITM_PANE_SELECTOR_NESTED";
    TestTag["MetricCard"] = "CRD_METRIC";
    TestTag["ScoreCard"] = "CRD_SCORE";
    TestTag["Pill"] = "LBL_PILL";
    TestTag["BtnDeleteReport"] = "BTN_DELETE_REPORT";
    TestTag["LnkReportItem"] = "LNK_REPORT_ITEM";
    TestTag["BtnDownloadSection"] = "BTN_DOWNLOAD_SECTION";
})(TestTag || (TestTag = {}));
export var tagDescriptions = (_a = {},
    _a[TestTag.ApplicationLogo] = {
        name: "Application Logo",
        tag: TestTag.ApplicationLogo,
        description: "Branding validation",
    },
    _a[TestTag.PrimaryPageHeader] = {
        name: "Primary Page Header",
        tag: TestTag.PrimaryPageHeader,
        description: "Page title verification",
    },
    _a[TestTag.HomePageHeaderContainer] = {
        name: "Home Page Header Container",
        tag: TestTag.HomePageHeaderContainer,
        description: "Homepage header wrapper",
    },
    _a[TestTag.SecondaryHeadingContainer] = {
        name: "Secondary Heading Container",
        tag: TestTag.SecondaryHeadingContainer,
        description: "Secondary heading wrapper",
    },
    _a[TestTag.EmailLabel] = {
        name: "Email Label",
        tag: TestTag.EmailLabel,
        description: "Label text validation",
    },
    _a[TestTag.EmailTextbox] = {
        name: "Email Textbox",
        tag: TestTag.EmailTextbox,
        description: "User input",
    },
    _a[TestTag.RememberMeCheckbox] = {
        name: "Remember Me Checkbox",
        tag: TestTag.RememberMeCheckbox,
        description: "State validation",
    },
    _a[TestTag.RememberMeLabel] = {
        name: "Remember Me Label",
        tag: TestTag.RememberMeLabel,
        description: "Label association",
    },
    _a[TestTag.UnlockAccountLink] = {
        name: "Unlock Account Link",
        tag: TestTag.UnlockAccountLink,
        description: "Navigation",
    },
    _a[TestTag.PrimaryActionButtonNext] = {
        name: "Primary Action Button Next",
        tag: TestTag.PrimaryActionButtonNext,
        description: "Primary action (Next)",
    },
    _a[TestTag.PrimaryActionButtonSubmit] = {
        name: "Primary Action Button Submit",
        tag: TestTag.PrimaryActionButtonSubmit,
        description: "Primary action (Submit)",
    },
    _a[TestTag.BtnBack] = {
        name: "Back Button",
        tag: TestTag.BtnBack,
        description: "Navigate back",
    },
    _a[TestTag.BtnCreateReport] = {
        name: "Create Report Button",
        tag: TestTag.BtnCreateReport,
        description: "Initiate report creation",
    },
    _a[TestTag.BtnSaveChanges] = {
        name: "Save Changes Button",
        tag: TestTag.BtnSaveChanges,
        description: "Persist edits",
    },
    _a[TestTag.BtnRevertChanges] = {
        name: "Revert Changes Button",
        tag: TestTag.BtnRevertChanges,
        description: "Undo edits",
    },
    _a[TestTag.BtnEditMode] = {
        name: "Edit Mode Button",
        tag: TestTag.BtnEditMode,
        description: "Enter edit mode",
    },
    _a[TestTag.BtnExitEditMode] = {
        name: "Exit Edit Mode Button",
        tag: TestTag.BtnExitEditMode,
        description: "Leave edit mode",
    },
    _a[TestTag.BtnSaveSettings] = {
        name: "Save Settings Button",
        tag: TestTag.BtnSaveSettings,
        description: "Persist settings",
    },
    _a[TestTag.BtnResetFilters] = {
        name: "Reset Filters Button",
        tag: TestTag.BtnResetFilters,
        description: "Clear all filters",
    },
    _a[TestTag.BtnInfoIcon] = {
        name: "Info Icon Button",
        tag: TestTag.BtnInfoIcon,
        description: "Open info panel",
    },
    _a[TestTag.BtnDownloadCsv] = {
        name: "Download CSV Button",
        tag: TestTag.BtnDownloadCsv,
        description: "Download data as CSV",
    },
    _a[TestTag.BtnNineBoxTableView] = {
        name: "Nine Box Table View Button",
        tag: TestTag.BtnNineBoxTableView,
        description: "Switch to table view",
    },
    _a[TestTag.BtnNineBoxGridView] = {
        name: "Nine Box Grid View Button",
        tag: TestTag.BtnNineBoxGridView,
        description: "Switch to grid view",
    },
    _a[TestTag.BtnSwitchToHeidrick] = {
        name: "Switch to Heidrick View",
        tag: TestTag.BtnSwitchToHeidrick,
        description: "Switch to Heidrick validation version",
    },
    _a[TestTag.BtnSwitchToConfidential] = {
        name: "Switch to Confidential View",
        tag: TestTag.BtnSwitchToConfidential,
        description: "Switch to confidential client version",
    },
    _a[TestTag.HelpLink] = {
        name: "Help Link",
        tag: TestTag.HelpLink,
        description: "Support navigation",
    },
    _a[TestTag.BreadcrumbItem] = {
        name: "Breadcrumb Item",
        tag: TestTag.BreadcrumbItem,
        description: "Breadcrumb navigation link",
    },
    _a[TestTag.BackToButton] = {
        name: "Back To Button",
        tag: TestTag.BackToButton,
        description: "Back navigation button",
    },
    _a[TestTag.BackToLink] = {
        name: "Back To Link",
        tag: TestTag.BackToLink,
        description: "Back navigation anchor",
    },
    _a[TestTag.HeaderContainer] = {
        name: "Header Container",
        tag: TestTag.HeaderContainer,
        description: "Main header wrapper",
    },
    _a[TestTag.HeaderAppBar] = {
        name: "Header App Bar",
        tag: TestTag.HeaderAppBar,
        description: "App bar strip",
    },
    _a[TestTag.HeaderMenuMyProfile] = {
        name: "Header Menu My Profile",
        tag: TestTag.HeaderMenuMyProfile,
        description: "My profile menu item",
    },
    _a[TestTag.HeaderBtnAccountMenu] = {
        name: "Header Account Menu Button",
        tag: TestTag.HeaderBtnAccountMenu,
        description: "Opens account menu",
    },
    _a[TestTag.HeaderMenuLogout] = {
        name: "Header Menu Logout",
        tag: TestTag.HeaderMenuLogout,
        description: "Logout menu item",
    },
    _a[TestTag.HeaderMenuSettings] = {
        name: "Header Menu Settings",
        tag: TestTag.HeaderMenuSettings,
        description: "Settings menu item",
    },
    _a[TestTag.DashboardPage] = {
        name: "Dashboard Page",
        tag: TestTag.DashboardPage,
        description: "Main dashboard page",
    },
    _a[TestTag.CohortInsightsPage] = {
        name: "Cohort Insights Page",
        tag: TestTag.CohortInsightsPage,
        description: "Cohort insights landing page",
    },
    _a[TestTag.FilteredOverviewPage] = {
        name: "Filtered Overview Page",
        tag: TestTag.FilteredOverviewPage,
        description: "Filtered overview container",
    },
    _a[TestTag.HeatmappedPage] = {
        name: "Heatmapped Page",
        tag: TestTag.HeatmappedPage,
        description: "Heatmap page container",
    },
    _a[TestTag.DashboardOuterContainer] = {
        name: "Dashboard Outer Container",
        tag: TestTag.DashboardOuterContainer,
        description: "Dashboard outer wrapper",
    },
    _a[TestTag.DashboardInnerContainer] = {
        name: "Dashboard Inner Container",
        tag: TestTag.DashboardInnerContainer,
        description: "Dashboard inner wrapper",
    },
    _a[TestTag.DiversitySettingsPanel] = {
        name: "Diversity Settings Panel",
        tag: TestTag.DiversitySettingsPanel,
        description: "Diversity settings container",
    },
    _a[TestTag.FiltersPanel] = {
        name: "Filters Panel",
        tag: TestTag.FiltersPanel,
        description: "Filter selection panel",
    },
    _a[TestTag.NineBoxFilterPanel] = {
        name: "Nine Box Filter Panel",
        tag: TestTag.NineBoxFilterPanel,
        description: "Nine box filter container",
    },
    _a[TestTag.SummaryPanel] = {
        name: "Summary Panel",
        tag: TestTag.SummaryPanel,
        description: "Summary data panel",
    },
    _a[TestTag.DialogContainer] = {
        name: "Dialog Container",
        tag: TestTag.DialogContainer,
        description: "Dialog wrapper",
    },
    _a[TestTag.TableContainer] = {
        name: "Table Container",
        tag: TestTag.TableContainer,
        description: "Data table wrapper",
    },
    _a[TestTag.FiltersBar] = {
        name: "Filters Bar",
        tag: TestTag.FiltersBar,
        description: "Horizontal filters bar",
    },
    _a[TestTag.OverviewTabsBar] = {
        name: "Overview Tabs Bar",
        tag: TestTag.OverviewTabsBar,
        description: "Tab navigation bar",
    },
    _a[TestTag.DropdownContainer] = {
        name: "Dropdown Container",
        tag: TestTag.DropdownContainer,
        description: "Action menu container",
    },
    _a[TestTag.DropdownOptionEdit] = {
        name: "Dropdown Option Edit",
        tag: TestTag.DropdownOptionEdit,
        description: "Edit action",
    },
    _a[TestTag.DropdownOptionArchive] = {
        name: "Dropdown Option Archive",
        tag: TestTag.DropdownOptionArchive,
        description: "Archive action",
    },
    _a[TestTag.OverflowMenuTrigger] = {
        name: "Overflow Menu Trigger",
        tag: TestTag.OverflowMenuTrigger,
        description: "Opens overflow menu",
    },
    _a[TestTag.MenuOptionDownloadReports] = {
        name: "Menu Option Download Reports",
        tag: TestTag.MenuOptionDownloadReports,
        description: "Download reports",
    },
    _a[TestTag.MenuOptionRegenerate] = {
        name: "Menu Option Regenerate",
        tag: TestTag.MenuOptionRegenerate,
        description: "Regenerate data",
    },
    _a[TestTag.DropdownSelector] = {
        name: "Dropdown Selector",
        tag: TestTag.DropdownSelector,
        description: "Action selector trigger",
    },
    _a[TestTag.OptionsListContainer] = {
        name: "Options List Container",
        tag: TestTag.OptionsListContainer,
        description: "Holds selectable options",
    },
    _a[TestTag.FooterCopyright] = {
        name: "Footer Copyright",
        tag: TestTag.FooterCopyright,
        description: "Footer text validation",
    },
    _a[TestTag.LeaderCount] = {
        name: "Leader Count",
        tag: TestTag.LeaderCount,
        description: "Leader count display",
    },
    _a[TestTag.CheckboxOption] = {
        name: "Checkbox Option",
        tag: TestTag.CheckboxOption,
        description: "Selectable checkbox option",
    },
    _a[TestTag.AutocompleteField] = {
        name: "Autocomplete Field",
        tag: TestTag.AutocompleteField,
        description: "Multi-select autocomplete input",
    },
    _a[TestTag.MultiSelectFilter] = {
        name: "Multi-Select Filter",
        tag: TestTag.MultiSelectFilter,
        description: "Multi-select filter dropdown",
    },
    _a[TestTag.FilterSection] = {
        name: "Filter Section",
        tag: TestTag.FilterSection,
        description: "Collapsible filter group",
    },
    _a[TestTag.FilterDropdownHeader] = {
        name: "Filter Dropdown Header",
        tag: TestTag.FilterDropdownHeader,
        description: "Filter section toggle header",
    },
    _a[TestTag.ToggleButton] = {
        name: "Toggle Button",
        tag: TestTag.ToggleButton,
        description: "On/off toggle control",
    },
    _a[TestTag.InfoBar] = {
        name: "Info Bar",
        tag: TestTag.InfoBar,
        description: "Contextual information bar",
    },
    _a[TestTag.OverviewTabPanel] = {
        name: "Overview Tab Panel",
        tag: TestTag.OverviewTabPanel,
        description: "Tab content panel",
    },
    _a[TestTag.OverviewTab] = {
        name: "Overview Tab",
        tag: TestTag.OverviewTab,
        description: "Individual navigation tab",
    },
    _a[TestTag.NavItem] = {
        name: "Navigation Item",
        tag: TestTag.NavItem,
        description: "Top-level navigation link",
    },
    _a[TestTag.PaneSelectorItem] = {
        name: "Pane Selector Item",
        tag: TestTag.PaneSelectorItem,
        description: "Root pane selector row",
    },
    _a[TestTag.PaneSelectorNestedItem] = {
        name: "Pane Selector Nested Item",
        tag: TestTag.PaneSelectorNestedItem,
        description: "Nested pane selector row",
    },
    _a[TestTag.MetricCard] = {
        name: "Metric Card",
        tag: TestTag.MetricCard,
        description: "KPI metric display card",
    },
    _a[TestTag.ScoreCard] = {
        name: "Score Card",
        tag: TestTag.ScoreCard,
        description: "Score display card",
    },
    _a[TestTag.Pill] = {
        name: "Pill",
        tag: TestTag.Pill,
        description: "Status pill label",
    },
    _a[TestTag.BtnDeleteReport] = {
        name: "Delete Report Button",
        tag: TestTag.BtnDeleteReport,
        description: "Delete a report",
    },
    _a[TestTag.LnkReportItem] = {
        name: "Report Item Link",
        tag: TestTag.LnkReportItem,
        description: "Navigate to a report",
    },
    _a[TestTag.BtnDownloadSection] = {
        name: "Download Section Button",
        tag: TestTag.BtnDownloadSection,
        description: "Download section as image",
    },
    _a);
export var getAutomationTag = function (tag, detail) { return ({
    "data-hs-id": detail ? "".concat(tag, "=\"").concat(detail, "\"") : tag,
}); };
